<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-select class="mb10 ml10" v-model="queryParam.codeType" placeholder="请选择容器类型" style="width: 200px">
              <el-option v-for="item in storeCodeTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="reset">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button class="ml10 mb10" type="primary" @click="handleAddCode">+生成容器码</el-button>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="lotNumber" align="center" label="批次号" />
      <el-table-column prop="codeType" align="center" label="容器码类型">
        <template slot-scope="scope">
          <span>{{storeCodeTypeMap[scope.row.codeType]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="num" align="center" label="二维码数量">
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="创建时间" />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="codeDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>
  </div>
</template>
<script>
  import { deleteCustomPageClass, pageClassList, noPage } from '@/api/customPageClass.js'
  import { selectCodeBatchList } from '@/api/storeCodeBatch.js'
  import { storeCodeTypeMap, storeTypeList } from '@/utils/constant'
  export default {
    components: {

    },
    props: {

    },
    data() {
      return {
        queryParam: {
          name: '',
          codeType: ''
        },
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        storeCodeTypeMap: storeCodeTypeMap,
        storeCodeTypeList: storeTypeList,
      };
    },
    created() {
      this.getList()
    },
    methods: {
      getCustomer() {
        this.getList()
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddCode(id) {
        this.$router.push({ path: '/store/addCode' })
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        params = Object.assign(params, this.queryParam)
        selectCodeBatchList(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      codeDetail(row) {
        this.$router.push({ path: '/store/codeDetail', query: { id: row.id, codeType: row.codeType } })
      },
      getTypeName() {

      },
      reset() {
        this.queryParam.name = ''
        this.queryParam.codeType = ''
        this.getList()
      }

    },

  }
</script>
<style scoped>
  .pageBox {
    display: flex;
    justify-content: flex-end;
  }
</style>